import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {
    Subscription,
    SubscriptionStatus
} from '../types';
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {CustomerLink} from "../links/CustomerLink.tsx";

export const getColumns = (onRecordClick?: (record: Subscription) => void) => [
    {
        title: I18n.get('Subscription ID'),
        width: '1fr',
        render: (item: Subscription) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.id}
            </span>
        ) : item.id,
    },
    {
        title: I18n.get('Customer'),
        width: '1fr',
        render: (item: Subscription) => <CustomerLink customer={item.customerId as string}/>,
    },
    {
        title: I18n.get('Start Date'),
        width: '1fr',
        render: (item: Subscription) => formatTimestamp(item.startDate * 1000),
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: Subscription) => <StatusBadge status={item.status as SubscriptionStatus}/>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Subscription) => formatTimestamp(item.created * 1000),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
